import * as Animate from "react-reveal";
import ComplianceImg from "../../../assets/images/png/pay/law changes woman on pc.png";
import SpecialistImg from "../../../assets/images/png/avatars/1.webp";

const checklist = [
  "Guided onboarding for your team",
  "Support through payroll review",
  "Practical country-by-country context",
];

const questions = [
  "“How should we set up this worker?”",
  "“What does this country require?”",
  "“When will this payout arrive?”",
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PaySupportSection = () => {
  return (
    <section
      className="grid pay-grid-support2 items-center gap-10 lg:gap-[75px] py-16 lg:py-[105px] px-6 lg:px-8"
      style={{ background: "#090d3c" }}
    >
      <Animate.Fade bottom>
        <div className="relative" style={{ height: "620px" }}>
          <img
            src={ComplianceImg}
            alt="A payroll specialist speaking with a global team"
            className="rounded-[27px] w-full h-full object-cover"
          />
          <div
            className="absolute grid items-center gap-[13px] rounded-[15px] p-[15px]"
            style={{
              gridTemplateColumns: "58px 1fr auto",
              bottom: "22px",
              left: "22px",
              right: "22px",
              background: "rgba(255,255,255,0.95)",
              boxShadow: "0 18px 45px rgba(0,0,0,0.22)",
            }}
          >
            <img
              src={SpecialistImg}
              alt="Utiva payroll specialist"
              className="rounded-full object-cover"
              style={{ width: "58px", height: "58px" }}
            />
            <p className="grid gap-[3px] m-0">
              <span className="text-[#966200] text-[15px] font-black">
                Your Payroll Specialist
              </span>
              <strong className="text-primary text-[16px]">
                Grace is reviewing your cycle
              </strong>
              <small className="text-[#5c6274] text-[15px]">
                Replies with context—not ticket numbers.
              </small>
            </p>
            <b
              className="rounded-full px-[10px] py-2 text-[15px] font-normal whitespace-nowrap"
              style={{ color: "#17713b", background: "#e9f8ee" }}
            >
              Online
            </b>
          </div>
        </div>
      </Animate.Fade>

      <Animate.Fade bottom>
        <div>
          <p className="text-secondary tracking-[0.1em] uppercase text-[15px] font-black mb-4">
            Support With Context
          </p>
          <h2
            className="text-white tracking-[-0.05em] leading-[1.06] font-black mb-6"
            style={{ fontSize: "clamp(38px, 4.4vw, 61px)" }}
          >
            Payroll questions deserve{" "}
            <mark style={markStyle}>human answers.</mark>
          </h2>
          <span className="text-[#d9ddf0] text-[18px] leading-[1.78] block">
            A contract detail, country requirement or payout question rarely
            fits neatly into a support ticket. Utiva gives your team a
            specialist who can understand the situation and help move it
            forward.
          </span>

          <ul className="grid gap-[10px] mt-[27px] p-0 list-none">
            {checklist.map((item) => (
              <li
                key={item}
                className="text-white text-[16px] rounded-[10px] px-[15px] py-3"
                style={{
                  background: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.14)",
                }}
              >
                <span className="text-secondary font-black mr-[11px]">✓</span>
                {item}
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-2 mt-[18px]">
            {questions.map((q) => (
              <span
                key={q}
                className="text-primary bg-white rounded-full px-3 py-[9px] text-[15px] font-extrabold"
              >
                {q}
              </span>
            ))}
          </div>

          <a
            href="https://app.utiva.co/signup?goal=workforce"
            target="_blank"
            rel="noreferrer noopener"
            className="text-secondary inline-flex items-center gap-[14px] text-[16px] font-black mt-[29px] hover:text-white transition"
          >
            Meet your payroll specialist <span aria-hidden="true">↗</span>
          </a>
        </div>
      </Animate.Fade>
    </section>
  );
};

export default PaySupportSection;
